/** NPC behavior catalog and wander tuning constants. */

export const NPC_BEHAVIORS = [
  { id: 'still', name: 'Still' },
  { id: 'wander', name: 'Wanderer' },
];

export const WANDER_RADII = [
  { id: 'close', name: 'Close', tiles: 10 },
  { id: 'medium', name: 'Medium', tiles: 20 },
  { id: 'far', name: 'Far', tiles: 40 },
];

export const DEFAULT_BEHAVIOR = 'still';
export const DEFAULT_WANDER_RADIUS = 'medium';

/** Tiles per second. Deliberately below the player's 4.375 so NPCs read as strolling. */
export const NPC_WALK_SPEED = 2;
export const STEP_MIN_TILES = 2;
export const STEP_MAX_TILES = 6;
export const IDLE_MIN_S = 1.5;
export const IDLE_MAX_S = 4.5;
/** Full inhale-exhale period of the standing bob, in seconds. */
export const BOB_PERIOD_S = 1.4;
/** Source row of the 24px frame where the torso ends and the legs begin. */
export const WAIST_ROW = 17;
/** Keep the current facing while ||dx| - |dy|| / distance is below this (near-45° steps). */
export const FACE_DEADBAND_RATIO = 0.15;

const BEHAVIOR_BY_ID = new Map(NPC_BEHAVIORS.map((entry) => [entry.id, entry]));
const RADIUS_BY_ID = new Map(WANDER_RADII.map((entry) => [entry.id, entry]));

export function isBehavior(id) {
  return BEHAVIOR_BY_ID.has(id);
}

export function isWanderRadius(id) {
  return RADIUS_BY_ID.has(id);
}

export function wanderRadiusTiles(id) {
  return (RADIUS_BY_ID.get(id) ?? RADIUS_BY_ID.get(DEFAULT_WANDER_RADIUS)).tiles;
}
